import type { TripOption, TripOptionsMatrix } from "@app/types/results-types";

import { getFromOptionsMatriceFirstCoordinateForATripId } from "../leg-cards/get-options";

// Maintains reference between renders
const EMPTY_ARR: TripOption[] = [];

export function getSelectedTripFares(
  leg_card_options_matrix: TripOptionsMatrix,
  selected_trip_id?: string
): TripOption[] {
  if (!selected_trip_id) {
    return EMPTY_ARR;
  }

  const [matrix_row_class_index] =
    getFromOptionsMatriceFirstCoordinateForATripId(
      leg_card_options_matrix,
      selected_trip_id
    );

  if (matrix_row_class_index === undefined) {
    return EMPTY_ARR;
  }

  // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  return leg_card_options_matrix[matrix_row_class_index];
}
